// Initialize toasts because Bootstrap doesn't do it itself

import { Toast } from 'bootstrap'

const toastElList = document.querySelectorAll('.toast')
const toastList = [...toastElList].map((toastEl) => {
  return new Toast(toastEl, { autohide: false }).show()
})
